import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { entityHeaderExtension, entityOverviewLayoutExtension } from './entity/entityExtensions';

export const catalogRdapFrontendModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [entityHeaderExtension, entityOverviewLayoutExtension],
});
